export const module4InitialState = {
  module4: {
    name: 'Posture',
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      Lion: false,
      Cheetah: false,
      Parrot: false,
      Tucan: false,
      JeepPink: false,
      JeepBlue: false,
      Elephants: false,
      Zebras: false,
      DrumPink: false,
      DrumBlue: false,
      Hippo: false,
      Flamingos: false,
      Camera: false,
      Binoculars: false,
      Ostrich: false,
      Giraffe: false,
      Hat: false,
      Bowtie: false,
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
      day9: false,
    },
  },
};

export const Module4Reducer = (state = module4InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE4_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        Lion: false,
        Cheetah: false,
        Parrot: false,
        Tucan: false,
        JeepPink: false,
        JeepBlue: false,
        Elephants: false,
        Zebras: false,
        DrumPink: false,
        DrumBlue: false,
        Hippo: false,
        Flamingos: false,
        Camera: false,
        Binoculars: false,
        Ostrich: false,
        Giraffe: false,
        Hat: false,
        Bowtie: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[]}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: true,
        day6: false,
        day7: false,
        day8: false,
        day9: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module4: {
          ...state.module4,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module4InitialState,
      };
    }
    case 'MODULE4_SET_DAY': {
      return {
        ...state,
        module4: {
          ...state.module4,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE4_SET_GameDetials': {
      return {
        ...state,
        module4: {
          ...state.module4,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE4_SET_stepCompleted': {
      return {
        ...state,
        module4: {
          ...state.module4,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE4_SET_dayCompleted': {
      return {
        ...state,
        module4: {
          ...state.module4,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE4_SET_CAMERAOPEN': {
      return {
        ...state,
        module4: {
          ...state.module4,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE4_SET_KEY': {
      return {
        ...state,
        module4: {
          ...state.module4,
          keys: action.payload,
        },
      };
    }
    case 'MODULE4_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module4: {
          ...state.module4,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE4_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module4: {
          ...state.module4,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE4_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module4: {
          ...state.module4,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE4_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module4: {
          ...state.module4,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE4_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module4: {
          ...state.module4,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE4_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module4: {
          ...state.module4,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE4_SET_REWARD11': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Lion: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD12': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Cheetah: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD21': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Parrot: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD22': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Tucan: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD31': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            JeepBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD32': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            JeepPink: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD41': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Zebras: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD42': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Elephants: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD51': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            DrumPink: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD52': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            DrumBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD61': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Hippo: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD62': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Flamingos: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD71': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Camera: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD72': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Binoculars: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD81': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Ostrich: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD82': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Giraffe: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_REWARD91': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Hat: action.payload,
          },
        },
      };
    }

    case 'MODULE4_SET_REWARD92': {
      return {
        ...state,
        module4: {
          ...state.module4,
          rewards: {
            ...state.module4.rewards,
            Bowtie: action.payload,
          },
        },
      };
    }

    case 'MODULE4_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }
    case 'MODULE4_SET_DAY_UNLOCK9': {
      return {
        ...state,
        module4: {
          ...state.module4,
          unlockedDays: {
            ...state.module4.unlockedDays,
            day9: action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
};
export default Module4Reducer;
